import { Link } from "react-router-dom";
import type { Film } from "@/mocks/films";

type FilmCardProps = {
  film: Film;
  index?: number;
  showTagline?: boolean;
};

export default function FilmCard({ film, index = 0, showTagline = false }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block w-full animate-rise"
      style={{ animationDelay: `${Math.min(index, 11) * 45}ms` }}
    >
      <div className="poster-frame relative w-full overflow-hidden rounded-lg border border-background-300 bg-background-200">
        <div className="relative aspect-[2/3] w-full overflow-hidden">
          <img
            src={film.poster}
            alt={`《${film.title}》影片海报`}
            title={`${film.title} ${film.genres.join(" ")} 海报`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90" />
          <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
            <span className="rounded-full bg-background-50/80 px-2 py-0.5 font-label text-[11px] tracking-wide text-foreground-800 backdrop-blur-sm">
              {film.year}
            </span>
            {film.categories.includes("classic") && (
              <span className="rounded-full bg-accent-500 px-2 py-0.5 font-label text-[10px] text-background-50">
                经典
              </span>
            )}
          </div>
          <div className="absolute inset-x-0 bottom-0 p-3">
            <p className="font-heading text-base font-bold leading-snug text-foreground-950">{film.title}</p>
            <p className="mt-0.5 truncate font-label text-[11px] uppercase tracking-[0.12em] text-foreground-500">
              {film.enTitle}
            </p>
          </div>
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex items-center gap-1.5 rounded-full border border-accent-500/60 bg-background-50/85 px-3.5 py-2 font-label text-xs text-accent-500 backdrop-blur-sm">
              查看详情
              <i className="ri-arrow-right-line" />
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2.5 flex flex-wrap items-center gap-x-2 gap-y-1">
        <span className="font-label text-xs text-foreground-500">{film.year}</span>
        <span className="h-1 w-1 rounded-full bg-foreground-400" />
        <span className="font-label text-xs text-foreground-600">{film.genres.join(" / ")}</span>
        <span className="h-1 w-1 rounded-full bg-foreground-400" />
        <span className="font-label text-xs text-foreground-500">{film.region}</span>
      </div>
      {showTagline && (
        <p className="mt-1.5 line-clamp-2 font-body text-xs leading-relaxed text-foreground-500">{film.tagline}</p>
      )}
    </Link>
  );
}